import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import '../translate';
import '../translate/translate';
import '../styles/ProviderHeader.css';

import ProfileModal from './ProfileModal';
import Detail from './Detail';
import Deposit from './Deposit';
import DepositBid from './DepositBid';
import Withdraw from './Withdraw';
import NavbarPanel from './NavbarPanel';
import Notifications from './Notifications';
import LanguageChange from './LanguageChange';

function Navbar({isDepositOpen, setIsDepositOpen}) {
    const [isProfileOpen, setIsProfileOpen] = useState(false)
    const [isDetailOpen, setIsDetailOpen] = useState(false)
    // const [isDepositOpen, setIsDepositOpen] = useState(false)
    const [isDepositBidOpen, setIsDepositBidOpen] = useState(false)
    const [isWithdrawOpen, setIsWithdrawOpen] = useState(false)
    const [isNavbarPanelOpen, setIsNavbarPanelOpen] = useState(false)
    const [isNotificationsOpen, setIsNotificationsOpen] = useState(false)

    const [depositAmount, setDepositAmount] = useState(null)
    const [depositMethod, setDepositMethod] = useState(null)
    const [depositWallet, setDepositWallet] = useState(null)
    const [depositExpiredAt, setDepositExpiredAt] = useState(null)
    const [depositDetailId, setDepositDetailId] = useState(null)
    const navigate = useNavigate();
    const { t } = useTranslation()

    return (
        <>
            <div className={'navbar-wrapper'}>
                <img src="/assets/img/main/Logo.png" alt="" />
                <div className={'navbar-list'}>
                    <div className={'navbar-list-item'}>
                        {/* <div onClick={() => setIsNavbarPanelOpen(true)}>
                            Profile
                        </div> */}
                        {/* <div className={'navbar-profile-dropdown'}>
                            <p>Phone Number:</p>
                            <span>+998 90 552 20 41</span>
                            <p>Email:</p>
                            <span>mzmz@mail.ru</span>
                            <p>Deposit</p>
                            <p>Withdraw</p>
                            <p>My Transactions</p>
                            <p>My Wallets</p>
                            <p>Verification status</p>
                            <p>Language</p>
                        </div> */}
                    </div>
                </div>
                <div style={{"display": "flex", "height": "100%", "justifyContent": "space-between", "alignItems": "center"}}>
                    <div className={'navbar-deposit-button-wrapper'} onClick={() => {
                        setIsDepositOpen(true)
                    }}>
                        {t("mp_deposit")}
                    </div>
                <div className={'navbar-client-wrap'} onClick={() => setIsNavbarPanelOpen(true)}>
                    <img src="/assets/img/burger-icon.svg" alt="" />
                </div>
                </div>
            </div>
            {isNavbarPanelOpen && <NavbarPanel setIsNavbarPanelOpen={setIsNavbarPanelOpen} setIsProfileOpen={setIsProfileOpen} setIsDetailOpen={setIsDetailOpen} setIsDepositOpen={setIsDepositOpen} setIsWithdrawOpen={setIsWithdrawOpen} setIsNotificationsOpen={setIsNotificationsOpen} />}
            {isProfileOpen && <ProfileModal setIsProfileOpen={setIsProfileOpen} setIsDepositOpen={setIsDepositOpen} setIsWithdrawOpen={setIsWithdrawOpen} />}
            {isDetailOpen && <Detail setIsDetailOpen={setIsDetailOpen} />}
            {isDepositOpen && <Deposit setIsDepositOpen={setIsDepositOpen} setIsDepositBidOpen={setIsDepositBidOpen} setDepositAmount={setDepositAmount} setDepositMethod={setDepositMethod} setDepositWallet={setDepositWallet} setDepositExpiredAt={setDepositExpiredAt} depositDetailId={depositDetailId} setDepositDetailId={setDepositDetailId} />}
            {isDepositBidOpen && <DepositBid setIsDepositBidOpen={setIsDepositBidOpen} depositAmount={depositAmount} depositMethod={depositMethod} depositWallet={depositWallet} depositExpiredAt={depositExpiredAt} depositDetailId={depositDetailId} />}
            {isWithdrawOpen && <Withdraw setIsWithdrawOpen={setIsWithdrawOpen} />}
            {isNotificationsOpen && <Notifications setIsNotificationsOpen={setIsNotificationsOpen} />}
            
        </>
    )
}

export default Navbar;